<!-- tabe切换 -->
<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="联系我们" name="first">
        <div class="card-imgFather">
          <img class="card-img" src="../../../assets/contactUs/contacUs.png" alt />
          <img class="card-img" src="../../../assets/contactUs/address.png" alt />
        </div>
      </el-tab-pane>
      <el-tab-pane label="招贤纳士" name="second">
        <joinUs></joinUs>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import joinUs from "./joinUs";
export default {
  data() {
    return { activeName: "first" };
  },

  components: {
    joinUs
  },

  mounted() {},

  methods: {
    handleClick(tab, event) {
      // console.log(tab, event.target);
    }
  }
};
</script>
<style>
.el-tabs__nav-wrap {
  width: 97vw;

  display: flex;
  justify-content: center;
  min-width: 1080px;
}
.el-tabs__nav-scroll {
  width: 160px;
}
.el-tabs__nav-wrap::after {
  background: #a0a0a0;
  height: 1px;
}
.card-imgFather {
  text-align: center;
}
.card-img {
  margin: 4% 3% 4% 3%;
}
</style>